import { FabricObjectWithSrc, mapRawToFabricImages, calculateZoom, ChangableFabricProps, StitchingManipulationRules } from '../../../shared/Helpers';

export type State = {
  fabricImages: FabricObjectWithSrc[];
  presentFabricImages: FabricObjectWithSrc[];
  rawImages: any[];
  leftScale: number;
  centringLeftScale: number;
  topScale: number;
  canvasWidth: number;
  canvasHeight: number;
  isStitched: boolean;
  zoom: number;
  pastFabricImages: FabricObjectWithSrc[][];
  futureFabricImages: FabricObjectWithSrc[][];
  reRender: boolean;
};

const updatePastState = (state: State, updatedImagePropsArray: ChangableFabricProps[], reRender: boolean) => {
  const { pastFabricImages, presentFabricImages } = state;

  let updatedFabricImages = [...presentFabricImages];

  for (const updatedImageProps of updatedImagePropsArray) {
    updatedFabricImages = updateLastFabricImages(updatedFabricImages, updatedImageProps);
  }

  return {
    ...state,
    pastFabricImages: [...pastFabricImages, [...presentFabricImages]],
    presentFabricImages: updatedFabricImages,
    futureFabricImages: [],
    reRender: reRender
  };
};

const updateLastFabricImages = (lastFabricImages: FabricObjectWithSrc[], updatedImageProps: ChangableFabricProps) => {
  return lastFabricImages.map(x => {
    if (x.name === updatedImageProps.name) {
      return {
        ...x,
        ...updatedImageProps
      };
    }
    return x;
  });
};

export type Action =
  | {
      type: 'ADD_TO_HISTORY';
      fabricImages: ChangableFabricProps[];
      reRender: boolean;
    }
  | { type: 'UNDO' }
  | { type: 'REDO' }
  | { type: 'SIZE_CHANGED'; canvasWidth: number; canvasHeight: number }
  | {
      type: 'UPDATE_REDUCER';
      rawImages: any[];
      subsampleFactor: number;
      isStitched: boolean;
    };

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'UPDATE_REDUCER': {
      const { isStitched, rawImages, subsampleFactor } = action;
      const { canvasHeight, canvasWidth } = state;
      const mappedData = mapRawToFabricImages({
        rawImages,
        isStitched,
        canvasHeight,
        canvasWidth,
        subsampleFactor
      });

      return {
        ...state,
        ...action,
        ...mappedData,
        presentFabricImages: [...mappedData.fabricImages],
        pastFabricImages: [],
        futureFabricImages: [],
        reRender: false
      };
    }
    case 'SIZE_CHANGED': {
      const { canvasHeight, canvasWidth } = action;
      const { fabricImages } = state;

      const zoom = calculateZoom(fabricImages, canvasHeight);

      return {
        ...state,
        canvasHeight,
        canvasWidth,
        zoom
      };
    }
    case 'ADD_TO_HISTORY': {
      const { fabricImages, reRender } = action;
      return updatePastState(state, fabricImages, reRender);
    }
    case 'UNDO': {
      const { pastFabricImages, presentFabricImages, futureFabricImages } = state;

      const previous = pastFabricImages[pastFabricImages.length - 1];
      const newPast = pastFabricImages.slice(0, pastFabricImages.length - 1);

      return {
        ...state,
        pastFabricImages: newPast,
        presentFabricImages: [...previous],
        futureFabricImages: [[...presentFabricImages], ...futureFabricImages],
        reRender: true
      };
    }
    case 'REDO': {
      const { futureFabricImages, pastFabricImages, presentFabricImages } = state;

      const next = futureFabricImages[0];
      const newFuture = futureFabricImages.slice(1);

      return {
        ...state,
        pastFabricImages: [...pastFabricImages, presentFabricImages],
        presentFabricImages: next,
        futureFabricImages: newFuture,
        reRender: true
      };
    }
  }
};

export { reducer };
